// extracted by mini-css-extract-plugin
module.exports = {"modal":"PatientsReassignment_modal__1ivdq","content":"PatientsReassignment_content__RhcYO","saveBtnWrapper":"PatientsReassignment_saveBtnWrapper__1eXiN"};